export default class OptionGenerator{
    constructor(){
        this.consonantPlaces    = ['bilabial', 'labiodental', 'alveolar', 'postalveolar', 'palatal', 'velar', 'glottal'];
        this.consonantManners   = ['plosive', 'nasal', 'tap-or-flap', 'fricative', 'affricate', 'approximant', 'lateral-approximant'];

        this.consonantVariants = ['postdorsal', 'predorsal', 'fricative', 'approximant', 'voiced', 'devoiced', 'bilabial', 'labiodental', 'alveolar', 'trill', 'tap-or-flap'];
    
        this.vowelBackness = ['front', 'central', 'back'];
        this.vowelHeight =   ['close', 'open-mid', 'open'];
        this.vowelRoundedness =   ['unrounded', 'rounded'];
        
        this.vowelVariants = ['postdorsal', 'predorsal', 'close', 'open', 'near-open'];
    }

    generatePlaceOptions(correctValue){
        // Check if correct value exists in possible consonant place values.
        if(!this.consonantPlaces.includes(correctValue)){
            console.error("OPTION_GENERATOR/GENERATE_OPLACE_OPTIONS/ERR_INV_CORRECT_VALUE");
            return true;
        }

        // Predefine variables.
        let correctIdx          = this.consonantPlaces.indexOf(correctValue);
        let randomIdx           = null;
        let randomIdxArr        = [];
        let randomPlaceOptions  = [];

        // Choose 3 unique random consonant place value.
        while(randomIdxArr.length !== 3){
            randomIdx = Math.floor(Math.random() * this.consonantPlaces.length);
            
            // Check if generated index is equal to correct value.
            if(randomIdx === correctIdx){
                continue;
            }

            // Check if generated index is duplicate of chosen ones.
            if(randomIdxArr.includes(randomIdx)){
                continue;
            }

            randomIdxArr.push(randomIdx);
        }

        // Generate a random (0-2) index which the correct index will be inserted to.
        randomIdx = Math.floor(Math.random() * 3);

        // Insert the correct index to the randomIdx.
        randomIdxArr[randomIdx] = correctIdx;

        // Generate the value equvalent array of random indexes.
        randomIdxArr.forEach((randomIdx) => {
            let randomConsonantPlace = this.consonantPlaces[randomIdx];
            randomPlaceOptions.push(randomConsonantPlace);
        });

        console.log("OPTION_GENERATOR/PLACE_OPTIONS");
        console.log(randomPlaceOptions);
        return randomPlaceOptions;
    }

    generateMannerOptions(correctValue){
        // Check if correct valu exists in possible consonant manner values.
        if(!this.consonantManners.includes(correctValue)){
            console.error("OPTION_GENERATOR/GENERATE_MANNER_OPTIONS/ERR_INV_CORRECT_VALUE");
            return false;
        }

        // Predefine variables.
        let correctIdx          = this.consonantManners.indexOf(correctValue);
        let randomIdx           = null;
        let randomIdxArr        = [];
        let randomMannerOptions = [];

        // Choose 3 unique random consonant manner value index.
        while(randomIdxArr.length !== 3){
            randomIdx = Math.floor(Math.random() * this.consonantManners.length);

            // Check if generated index is equal to correct value's index.
            if(randomIdx === correctIdx){
                continue;
            }

            // Check if generated index is duplicate of chosen ones.
            if(randomIdxArr.includes(randomIdx)){
                continue;
            }

            randomIdxArr.push(randomIdx);
        }

        // Generate a random (0-2) index which the correct index will be inserted to.
        randomIdx = Math.floor(Math.random() * 3);

        // Insert the correct index to the randomIdx.
        randomIdxArr[randomIdx] = correctIdx;

        // Generate the value equivalent array of random indexes.
        randomIdxArr.forEach((randomIdx) => {
            let randomConsonantManner = this.consonantManners[randomIdx];
            randomMannerOptions.push(randomConsonantManner);
        });

        console.log("OPTION_GENERATOR/MANNER_OPTIONS");
        console.log(randomMannerOptions);
        return randomMannerOptions;
    }

    generateConsonantVariantOptions(correctValue){
        // Check if correct value exists in possible consonant variant values.
        if(!this.consonantVariants.includes(correctValue)){
            console.error("OPTION_GENERATOR/GENERATE_CONSONANT_VARIANT_OPTIONS/ERR_INV_CORRECT_VALUE");
            return false;
        }

        // Predefine variables.
        let correctIdx   = this.consonantVariants.indexOf(correctValue);
        let randomIdx    = null;
        let randomIdxArr = [];
        let randomConsonantVariantOptions = [];

        // Choose 6 unique random consonant variant value index.
        while(randomIdxArr.length !== 6){
            randomIdx = Math.floor(Math.random() * this.consonantVariants.length);

            // Check if generated index is equal to correct value's index.
            if(randomIdx === correctIdx){
                continue;
            }

            // Check if generated index is duplicate of chosen ones.
            if(randomIdxArr.includes(randomIdx)){
                continue;
            }

            randomIdxArr.push(randomIdx);
        }

        // Generate a random (0-5) index which the correct index will be inserted to.
        randomIdx = Math.floor(Math.random() * 6);

        // Insert the correct index to the randomIdx.
        randomIdxArr[randomIdx] = correctIdx;

        // Generate the value equivalent array of random indexes.
        randomIdxArr.forEach((randomIdx) => {
            let randomConsonantVariant = this.consonantVariants[randomIdx];
            randomConsonantVariantOptions.push(randomConsonantVariant);
        });

        console.log("OPTION_GENERATOR/CONSONANT_VARIANT_OPTIONS");
        console.log(randomConsonantVariantOptions);
        return randomConsonantVariantOptions;
    }

    generateVowelBacknessOptions(oldOptions){

        // Predefine variables.
        let randomIdx    = null;
        let options      = [];

        while(true){

            // Reset options.
            options = [];

            // Generate options.
            while(options.length !== 3){

                // Generate random index.
                randomIdx = Math.floor(Math.random() * this.vowelBackness.length);

                // Check if candidate option has already been chosen before.
                if(options.includes(this.vowelBackness[randomIdx])){
                    continue;
                }

                options.push(this.vowelBackness[randomIdx]);
            }

            // Check if generated options are identical to the old options
            if(JSON.stringify(options) !== JSON.stringify(oldOptions)){
                break;
            }
            else{
                console.warn("IDENTICAL");
            }
        }

        console.log("OPTION_GENERATOR/BACKNESS_OPTIONS");
        console.log(options);
        return options;
    }

    generateVowelHeightOptions(oldOptions){

        // Predefine variables.
        let randomIdx = null;
        let options   = [];

        while(true){

            // Reset options.
            options = [];
            
            // Generate 3 options.
            while(options.length !== 3){

                // Generate a random index.
                randomIdx = Math.floor(Math.random() * this.vowelHeight.length);

                // Check if candidate option is has already been chosen before.
                if(options.includes(this.vowelHeight[randomIdx])){
                    continue;
                }

                options.push(this.vowelHeight[randomIdx]);
            }

            // Check if generated options are identical to the old options.
            if(JSON.stringify(options) !== JSON.stringify(oldOptions)){
                break;
            }
            else{
                // console.warn("OPTION_GENERATOR/GENERATE_VOWEL_HEIGHT_OPTIONS::IDENTICAL");
                // console.warn('options: ' + JSON.stringify(options) + ' === ' + 'oldOptions: ' + JSON.stringify(oldOptions))
            }
        }

        console.log("OPTION_GENERATOR/HEIGHT_OPTIONS");
        console.log(options);
        return options;
    }

    generateVowelRoundednessOptions(){
        
        // Predefine variables.
        let randomIdx = null;
        let options   = [];

        while(options.length !== 2){

            // Generate a random index.
            let randomIdx = Math.floor(Math.random() * this.vowelRoundedness.length);

            // Check if candidate option has already been chosen before.
            if(options.includes(this.vowelRoundedness[randomIdx])){
                continue;
            }

            options.push(this.vowelRoundedness[randomIdx]);
        }

        console.log("OPTION_GENERATOR/ROUNDEDNESS_OPTIONS");
        console.log(options);
        return options;
    }

    generateVowelVariantOptions(oldOptions){

        // Predefine variables.
        let randomIdx = [];
        let options   = [];

        while(options.length !== 5){

            // Generate a random index.
            randomIdx = Math.floor(Math.random() * this.vowelVariants.length);

            // Check if candidate option has already been chosen before.
            if(options.includes(this.vowelVariants[randomIdx])){
                continue;
            }

            options.push(this.vowelVariants[randomIdx]);
        }

        console.log("OPTION_GENERATOR/VOWEL_VARIANT_OPTIONS");
        console.log(options);
        return options;
    }
}